import React, { useEffect, useState } from 'react';
import { Clock3Icon, EyeIcon, SparklesIcon } from 'lucide-react';
interface OfferTime {
  day: string;
  hours: string;
  minutes: string;
  seconds: string;
}
function getOfferTime(): OfferTime {
  const now = new Date();
  const midnight = new Date(now);
  midnight.setHours(24, 0, 0, 0);
  const seconds = Math.floor(Math.max(0, midnight.getTime() - now.getTime()) / 1000);
  return {
    day: new Intl.DateTimeFormat('en-US', {
      weekday: 'long'
    }).format(now).toUpperCase(),
    hours: String(Math.floor(seconds / 3600)).padStart(2, '0'),
    minutes: String(Math.floor(seconds % 3600 / 60)).padStart(2, '0'),
    seconds: String(seconds % 60).padStart(2, '0')
  };
}
export function TodayOfferCard() {
  const [offerTime, setOfferTime] = useState<OfferTime>(getOfferTime);
  useEffect(() => {
    const timer = window.setInterval(() => setOfferTime(getOfferTime()), 1000);
    return () => window.clearInterval(timer);
  }, []);
  return <aside aria-label="Information about today's offer" className="mt-4 overflow-hidden rounded-2xl border border-gold bg-navy-mid px-4 py-4 text-white shadow-[0_14px_30px_-18px_rgba(0,0,0,0.8)] sm:px-5" data-id="element-205" data-mp="j6tlgd5p8vbr">
      <div className="flex flex-col items-center gap-3 text-center sm:flex-row sm:justify-between sm:gap-5 sm:text-left" data-id="element-206" data-mp="s7rnwr0hous8">
        <div className="min-w-0" data-id="element-207" data-mp="n9q5m8aw0zht">
          <span className="inline-flex items-center gap-1.5 rounded-full border border-gold/60 bg-gold/10 px-2.5 py-1 text-[11px] font-bold tracking-[0.12em] text-gold" data-id="element-208" data-mp="n6lv6t6tx7ip">
            <SparklesIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-209" data-mp="3ro7vqfeitlpm" /> TODAY&apos;S OFFER AVAILABLE
          </span>
          <p className="mt-2 text-xs font-medium uppercase tracking-[0.18em] text-white/65" data-id="element-210" data-mp="9aqhd1raemm6">
            {offerTime.day}
          </p>
          <p className="mt-1 text-sm leading-snug text-white/85" data-id="element-211" data-mp="3cxh3j690oklz">
            This offer ends at midnight tonight, based on your local time zone.
          </p>
        </div>
        <div className="flex shrink-0 items-center gap-3" role="timer" aria-live="off" data-id="element-212" data-mp="37wtcwlopa5sa">
          <Clock3Icon className="hidden h-5 w-5 text-gold sm:block" aria-hidden="true" data-id="element-213" data-mp="1btevvjkgjkd3" />
          <TimeUnit value={offerTime.hours} label="HRS" data-id="element-214" data-mp="1gsrhk0zlele3" />
          <span className="pb-4 font-display text-2xl font-bold text-gold" data-id="element-215" data-mp="1ll2gp1mie35l">:</span>
          <TimeUnit value={offerTime.minutes} label="MIN" data-id="element-216" data-mp="1qk5lqm2ho9dk" />
          <span className="pb-4 font-display text-2xl font-bold text-gold" data-id="element-217" data-mp="1qjm31350lgyh">:</span>
          <TimeUnit value={offerTime.seconds} label="SEC" data-id="element-218" data-mp="sxyfz8ug8azm" />
        </div>
      </div>
      <div className="mt-3 flex items-center justify-center gap-2 border-t border-gold/25 pt-3 text-center text-xs text-white/65 sm:justify-start" data-id="element-219" data-mp="xwsye9oi7xj7">
        <EyeIcon className="h-3.5 w-3.5 shrink-0 text-gold" aria-hidden="true" data-id="element-220" data-mp="12x78dx9o1hjv" />
        <span data-id="element-221" data-mp="16xr7359w0t84">Review today&apos;s offer before it ends.</span>
      </div>
    </aside>;
}
function TimeUnit({
  value,
  label
}: {
  value: string;
  label: string;
}) {
  return <div className="flex min-w-[38px] flex-col items-center" data-id="element-222" data-mp="2iaa30buycgak">
      <span className="font-display text-3xl font-bold leading-none text-gold sm:text-4xl" data-id="element-223" data-mp="6nzv0c4kkv66">
        {value}
      </span>
      <span className="mt-1 text-[10px] font-semibold tracking-[0.13em] text-white/55" data-id="element-224" data-mp="2mee8fowzwqp">
        {label}
      </span>
    </div>;
}